import { dailyPayoutDetailQuery } from "@/api/reporting";
import { DataTable } from "@/components/data-table/DataTable";
import { DataTableBody } from "@/components/data-table/DataTableBody";
import { StyledLink } from "@/components/link/StyledLink";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { formatDate } from "@common/utils/date";
import { Box } from "@givenwell/components";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { fallback, object, optional, pipe, string, transform } from "valibot";

const route = getRouteApi("/admin/reports/$countryCode/daily-payouts/detail");

function optionalStringToOptionalDate(dateStr: string = "") {
  const date = new Date(dateStr);
  if (!isNaN(date.getTime())) {
    return date;
  }
  return undefined;
}

export const Route = createFileRoute("/admin/reports/$countryCode/daily-payouts/detail")({
  component: SupplierDailyPayoutsDetail,
  validateSearch: object({
    from: fallback(pipe(optional(string()), transform(optionalStringToOptionalDate)), undefined),
    to: fallback(pipe(optional(string()), transform(optionalStringToOptionalDate)), undefined),
  }),
  beforeLoad: () => ({
    breadcrumb: "Transactions",
  }),
});

function SupplierDailyPayoutsDetail() {
  const { countryCode } = route.useParams();
  const { from, to } = route.useSearch();

  const query = useQuery(dailyPayoutDetailQuery(countryCode, from?.toISOString() || "", to?.toISOString() || ""));

  return (
    <PageWrapper title="Supplier — Daily Payouts">
      <Box css={{ spaceY: 16 }}>
        <DataTable>
          <DataTableBody
            data={query.data ?? []}
            status={query.status}
            rounded="full"
            columns={[
              {
                header: "Friendly ID",
                cell: "friendly_id",
              },
              {
                header: "Day",
                cell: row => formatDate(row.created_at),
              },
              {
                header: "Supplier",
                cell: row => (
                  <StyledLink to={`/admin/suppliers/$supplierId`} params={{ supplierId: row.supplier_id }}>
                    {row.supplier_name}
                  </StyledLink>
                ),
              },
              {
                header: "GST $",
                cell: "payment_tax_amount",
                formatter: "currency",
              },
              {
                cell: "payment_total_amount",
                header: "Total $",
                formatter: "currency",
              },
            ]}
            dataKey="payout_id"
          />
        </DataTable>
      </Box>
    </PageWrapper>
  );
}
